import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTagModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

import { TabsRow } from './tabs-row.component';

@NgModule({
	declarations: [TabsRow],
	imports: [
		CommonModule,
		FreudTagModule,
		TranslateModule.forChild(),
		TooltipModule,
	],
	exports: [TabsRow],
	providers: [],
})
export class TabsRowModule {}
